/* Repeat the mountain strip around a stable central copy; never autoplay. */
(() => {
  const init = root => {
    const rail = root.querySelector('[data-works-rail]');
    if (!rail || rail.dataset.loopReady) return;
    rail.dataset.loopReady = 'true';
    const originals = [...rail.querySelectorAll('.nk-works__card')];
    let period = 0, origin = 0, rebuilding = false, lastWidth = 0;
    const position = root.querySelector('[data-loop-position]');
    const updatePosition = () => {
      if (!position) return;
      const left = rail.getBoundingClientRect().left + Math.min(rail.clientWidth * .3, 220);
      const cards = [...rail.querySelectorAll('.nk-works__card:not([hidden])')];
      const card = cards.find(el => {const b=el.getBoundingClientRect();return b.left<=left && b.right>left;});
      const count = originals.filter(el=>!el.hidden).length;
      position.textContent = String((count ? Number(card?.dataset.loopIndex ?? 0)+1 : 0)).padStart(2,'0') + ' / ' + String(count).padStart(2,'0');
    };
    const clone = card => {
      const copy = card.cloneNode(true);
      copy.dataset.loopClone = '';
      copy.setAttribute('aria-hidden', 'true');
      copy.tabIndex = -1;
      copy.removeAttribute('id');
      copy.removeAttribute('data-shopify-editor-block');
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      copy.querySelectorAll('a,button,input,[tabindex]').forEach(el => el.tabIndex = -1);
      return copy;
    };
    const rebuild = () => {
      rebuilding = true;
      rail.querySelectorAll('[data-loop-clone]').forEach(el => el.remove());
      const visible = originals.filter(el => !el.hidden);
      visible.forEach((el,i)=>el.dataset.loopIndex=String(i));
      period = visible.reduce((sum, el) => {
        const css = getComputedStyle(el);
        return sum + el.getBoundingClientRect().width + parseFloat(css.marginLeft || 0) + parseFloat(css.marginRight || 0);
      }, 0);
      if (period > 0) {
        const copies = Math.ceil(rail.clientWidth / period) + 2;
        const before = document.createDocumentFragment(), after = document.createDocumentFragment();
        for (let n = 0; n < copies; n++) visible.forEach(el => {before.append(clone(el)); after.append(clone(el));});
        rail.prepend(before);
        rail.append(after);
        origin = period * copies;
        rail.scrollTo({left:origin, behavior:'instant'});
      }
      lastWidth = rail.clientWidth;
      rebuilding = false;
      updatePosition();
    };
    rail.addEventListener('scroll', () => {
      if (rebuilding || period <= 0) return;
      const delta = rail.scrollLeft - origin;
      if (delta < -period / 2 || delta > period / 2) {
        // Shift by complete strips, leaving the same pixels under the pointer.
        rail.scrollTo({left:rail.scrollLeft - Math.round(delta / period) * period, behavior:'instant'});
      }
      updatePosition();
    }, {passive:true});
    root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', rebuild));
    if ('ResizeObserver' in window) new ResizeObserver(() => {
      if (Math.abs(rail.clientWidth-lastWidth) > 1) rebuild();
    }).observe(rail);
    rebuild();
  };
  document.querySelectorAll('[data-works-loop]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-works-loop]').forEach(init));
})();
